import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import BoxWrapper from 'components/Wrapper/BoxWrapper';
import { motion, useScroll } from "framer-motion"
import SectionWrapper from 'components/Wrapper/SectionWrapper';
import Banner from 'components/Banner/Banner';
import { imgUrls } from 'constants/imgUrls';
import ContactForm from './Sections/ContactForm';
import FindUsMap from './Sections/FindUsMap';
import { SectionTitle } from 'components/Sections/SectionTitle';

const ContactUs = () => {
    const { scrollYProgress, scrollXProgress } = useScroll();

    return (
        <>
            <Banner imgUrl={imgUrls.contactUsBanner} />

            <motion.div 
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >

            {/* as={motion.section} animate={{ y: 0 }} */}
            <SectionWrapper>
                <SectionTitle title="CONTACT US"></SectionTitle>
                <Container>
                    <Row>
                        <Col>
                            <BoxWrapper as={motion.div} animate={{ y: 10 }}>
                                <address>
                                    <strong>Address</strong><br />
                                    724/4, Malawani 4 No.,<br />
                                    Opp Malawani Police Station,<br />
                                    Mumbai – 400095. Maharashtra, India
                                </address>
                            </BoxWrapper>
                            <BoxWrapper as={motion.div} animate={{ y: 10 }}>
                                <strong>Call</strong><br />
                                Phone +91 8080387206
                            </BoxWrapper>
                            <BoxWrapper as={motion.div} animate={{ y: 10 }}>
                                <strong>Email</strong><br />
                                krishnadigitalprint@gmail.com<br />
                                shreekrishnazerox@gmail.com
                            </BoxWrapper>
                        </Col>
                        <Col>
                            <ContactForm />
                        </Col>
                    </Row>
                </Container>
            </SectionWrapper>
            </motion.div>
            <SectionWrapper bgc='silver' as={motion.section} animate={{ y: 0 }}>
                <Container>
                    <Row>
                        <Col>
                            <FindUsMap />
                        </Col>
                    </Row>
                </Container>
            </SectionWrapper>
        </>
    )
}

export default ContactUs